function devSwitchInit() {

  $('[data-dev-switcher]').each(function() {

    var keys  = $.map($(this).attr('data-dev-switcher').split(','), function(value){
      return parseInt(value, 10);
    });

    $(this).find('[data-dev-switcher-id!='+keys[0]+']').hide();
    $(document).keydown(function (e) {
      if ($.inArray(e.keyCode, keys) > -1) {
        $('[data-dev-switcher] [data-dev-switcher-id]').hide();
        $('[data-dev-switcher] [data-dev-switcher-id='+e.keyCode+']').show();
      }
      console.log(e.keyCode);
    });

  });

}

if( $('[data-dev-switcher]').length > 0 ) {
  devSwitchInit();
}
